var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-group registration" },
      [
        _c("Pincode", { on: { pinready: _vm.setPin } }),
        _vm._v(" "),
        _c("input", {
          attrs: {
            type: "hidden",
            id: "confirmPhone",
            name: "confirmPhone",
            required: "required",
          },
          domProps: { value: _vm.pin },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }